import React from 'react';

import InsuranceIcon from '@/assets/insurance.svg?react';
import LockClosedIcon from '@/assets/lock-closed.svg?react';
import { UiTypography } from '@/components/ui/Typography';

import {
  PaymentProtectionsDividerStyles,
  PaymentProtectionsItemStyles,
  PaymentProtectionsStyles,
} from './PaymentProtections.styles';

interface PaymentProtectionsProps {
  theme?: 'dark-violet' | 'domination' | 'dark-forest' | null;
}
export const PaymentProtections: React.FC<PaymentProtectionsProps> = ({
  theme,
}) => {
  return (
    <PaymentProtectionsStyles theme={theme}>
      <PaymentProtectionsItemStyles>
        <LockClosedIcon />
        <UiTypography variant="label-small">
          Secure SSL <br /> Encryption
        </UiTypography>
      </PaymentProtectionsItemStyles>

      <PaymentProtectionsDividerStyles />

      <PaymentProtectionsItemStyles>
        <InsuranceIcon />
        <UiTypography variant="label-small">
          Guaranteed <br /> Safe Checkout
        </UiTypography>
      </PaymentProtectionsItemStyles>
    </PaymentProtectionsStyles>
  );
};
